// extracted by mini-css-extract-plugin
module.exports = {"block":"block__1MdAi","blockimg":"blockimg__3w7Ue"};